import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import * as React from 'react';

import { AdminSidebar } from '@/components/admin/admin-sidebar';
import { AdminTopbar } from '@/components/admin/admin-topbar';
import { AppContentArea } from '@/components/app/app-content-area';
import { trpcVanilla } from '@/lib/trpc/shared';

export const Route = createFileRoute('/_admin')({
  beforeLoad: async () => {
    const me = await trpcVanilla.user.me.query().catch(() => null);
    if (!me) {
      throw redirect({ to: '/sign-in' });
    }
    if (!me.isAdmin || me.status !== 'ACTIVE') {
      throw redirect({ to: '/dashboard' });
    }
    return { me };
  },
  component: AdminLayout,
});

function AdminLayout(): React.ReactElement {
  const { me } = Route.useRouteContext();
  const displayName = me.displayName ?? '';
  const email = me.email;
  const role = me.role;
  const avatarUrl = me.avatarUrl ?? null;

  return (
    <>
      <a
        href="#admin-content"
        className="focus:bg-primary focus:text-primary-foreground sr-only focus:not-sr-only focus:absolute focus:top-3 focus:left-3 focus:z-50 focus:rounded-md focus:px-3 focus:py-2"
      >
        Aller au contenu
      </a>
      <div className="bg-background flex h-dvh flex-col">
        <AdminTopbar user={{ displayName, email, role, avatarUrl }} />
        <div className="flex min-h-0 flex-1">
          <AdminSidebar />
          <main
            id="admin-content"
            className="bg-surface border-border flex min-w-0 flex-1 flex-col overflow-hidden rounded-tl-3xl border-t border-l"
          >
            <AppContentArea>
              <Outlet />
            </AppContentArea>
          </main>
        </div>
      </div>
    </>
  );
}
